import React from 'react';
import ReactDOM from 'react-dom';
import FormControl from './FormControl';
import Select from 'react-select';
import { debounce, isEqual } from 'lodash';
import SortableItem from '../ControlHelpers/SortableItem';
import SortableContainer from '../ControlHelpers/SortableContainer';
import { checkError, getSelectData, selectOnChange, onFocus, multiSelectPropTypes, defaultMultiselectProps, translationProps, rendererProps, autoComplete } from '../ControlHelpers/SelectUtils.js';
import update from 'immutability-helper';
import classNames from 'classnames';
import Chip from '../../Chip';

export default class SelectSortableControl extends FormControl{
  static propTypes = multiSelectPropTypes;
  static defaultProps = defaultMultiselectProps

  constructor(props){
    super(props);
    let value = props.initialData;
    if (value && !value.display){
      if (props.buildDisplay){
        value.display = props.buildDisplay(value);
      } else {
        value.display = value[props.displayProperty || props.labelKey];
      }
    }
    this.state = { value, isLoading: false };
    this.debouncedGetData = debounce(this.getData, props.valueChangeDelay, { leading: false, trailing: true });

    if(value && value.display) {
      this.onChange(this.state.value);
    }

  }

  componentWillReceiveProps(newProps) {
    if (!isEqual(this.props.filters, newProps.filters) || this.props.dataUrl !== newProps.dataUrl) {
      this.onChange();
    }
    if(newProps.valueOverride && newProps.dataValue !== this.state.value){
      this.onChange(newProps.dataValue, true)
    }
  }

  onChange = (val, skipValueChange) => {
    const value = selectOnChange(val, this.props, this.select, skipValueChange);
    this.setState({ ...this.state, value });
  }

  getData = async (input, callback) => {
    this.setState({ isLoading: true });
    const options = await getSelectData(input, this.props);
    this.setState({ isLoading: false });
    callback(null, { options });
  }

  onFocus = (e) => {
    onFocus(e, this.props);
  }

  checkAndLoadOptions = (input, callback) => {
    if (!input && this.props.requireInput) {
      return Promise.resolve({ options: [] });
    } else {
      this.debouncedGetData(input, callback);
    }
  };

  onBlur = () => {
    if (typeof this.props.onBlur === 'function'){
      this.props.onBlur(this.state.value);
    }
    this.checkError();
  };

  onRef = (select) => {
    this.select = select;
    if (this.select) {
      this.input = ReactDOM.findDOMNode(this.select).querySelector('input');
    }
  }

  removeEntry = (e, value) => {
    const key = this.props.valueKey && value[this.props.valueKey] ? this.props.valueKey : 'id';
    this.setState({ value: this.state.value.filter((val) => {
      if(typeof val === 'string') {
        return val !== value[key]
      } else {
        return val[key] !== value[key]
      }
    }) });
    e.stopPropagation();
    e.preventDefault();
  }

  valueComponent = props => <>{props.children}</>;

  valueRenderer = (val, index) => {
    const label = val.display ? val.display : this.props.labelKey ? val[this.props.labelKey] : val.label;
    return (
      <SortableItem
        index={index}
        className={classNames('sortable-item', 'Select-value')}
        swapItems={this.swapItems}>
        <Chip
          value={label}
          sortable={true}
          onRemove={e => this.removeEntry(e, val)}
          roll="option"
        />
      </SortableItem>
    );
  }

  swapItems = (dragIndex, hoverIndex) => {
    const dragItem = this.state.value[dragIndex];
    this.setState(update(this.state, {
      value: {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragItem]
        ]
      }
    }));
  }

  checkError() {
    checkError(this.props, this.select);
  }

  render(){
    let { setError, name, cacheEnabled, ...props } = this.props;  // eslint-disable-line no-unused-vars
    const SelectedComponent = props.dataUrl ? Select.Async : Select;
    return (
      <SortableContainer>
        <SelectedComponent
          {...props}
          {...translationProps}
          {...rendererProps(true)}
          aria-labelledby={`${this.props.name}-label`}
          cache={cacheEnabled}
          inputProps={autoComplete(this.props)}
          isLoading={this.state.isLoading}
          loadOptions={this.checkAndLoadOptions}
          labelKey={props.dataUrl ? "display" : props.labelKey}
          placeholder={this.props.placeholderText}
          name={name + `[]`}
          multi={true}
          onBlur={this.onBlur}
          onChange={this.onChange}
          onOpen={this.onOpen}
          ref={this.onRef}
          scrollMenuIntoView={false}
          closeOnSelect={false}
          removeSelected={false}
          value={this.state.value}
          valueRenderer={this.valueRenderer}
          valueComponent={this.valueComponent}
        />
      </SortableContainer>
    );
  }
}

